import React, { Component } from "react";
import UpdateExpirenceSummary from "./updateExpirenceSummary";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import PopUpContact from "../../../../common/popupcontact";
/**
 * ContactDetails Component for displaying the user contact details.
 */
class Expirence extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addBtn: false,
      updateBtn: false,
      data: [],
      validid: false,
      isOpen: false,
    };
    this.openAddForm = this.openAddForm.bind(this);
    this.closeAddForm = this.closeAddForm.bind(this);
    this.openUpdateForm = this.openUpdateForm.bind(this);
    this.closeUpdateForm = this.closeUpdateForm.bind(this);
    this.getData = this.getData.bind(this);
  }

  // open add form

  openAddForm() {
    this.setState({
      addBtn: true,
    });
  }
  // close add form
  closeAddForm() {
    this.setState({
      addBtn: false,
    });
  }
//  open update form
  openUpdateForm() {
    this.setState({
      updateBtn: true,
    });
  }
// close update form
  closeUpdateForm() {
    this.setState({
      updateBtn: false,
    });
    this.getData();
  }

  componentDidMount() {
    this.getData();
  }

  // get exp -summary function
  getData() {
    axios
      .get(`${API_CANDIDATE}/v1/api/can-exp-summary`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          data: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  render() {
    const { addBtn, updateBtn, data } = this.state;

    return (
      <>
      {/* applied ternary operator */}
        {!addBtn && !updateBtn ? (
          <>
              <div
              style={{
                height: "40px",
                display: "flex",
                flexDirection: "row",
                // justifyContent: "flex-end",
                // alignItems: "center",
              }}
            >
              <div style={{width:"60%",display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                <h5  style={{ fontWeight: 500,fontSize:"1.25rem" }} className='carrer-res'> Experience Summary</h5>
              </div>

              <div style={{width:"40%"}}>
                <i
                  style={{
                    marginRight: "80px",
                    marginTop: "5px",
                    color: "green",
                  }}
                  className="material-icons pointer contact-edit-btn"
                  onClick={this.openUpdateForm}
                >
                  edit
                </i>
              </div>
            </div>

            <ul>
            <div className="details-flex-main-div">
                <div className="contact-details-flex-div-one ">
                  Experience Summary
                </div>
                <div className="details-flex-div-two">:</div>
                <div className="details-flex-div-three">
                  {data.length ? data[0].experienceSumm : null}
                </div>
            </div>

            <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Domain Experience 
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].domainExpSum : null}
                  </div>
                </div>
              </li>
              
              
          
            

              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Relevant Experience
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].relYearOfExp : null}
                  </div>
                </div>
              </li>

            
            </ul>
            {this.state.isOpen && (
              <PopUpContact
                isOpenModal={this.togglePopup}
                isOnDelete={this.deleteData}
              />
            )}
          </>
        ) : null}
        {updateBtn && (
          <UpdateExpirenceSummary back={this.closeUpdateForm} data={data} />
        )}
      </>
    );
  }
}

export default Expirence;
